/*
 * @Description: 功能描述
 * @Version: 1.0
 * @Author: Yuchuan
 * @Date: 2022-01-17 11:23:34
 */
import Vue from 'vue'
import App from './App.vue'
import VueLazyLoad from 'vue-lazyload'
import imgLoading from '../../../public/static/img/loadingGif.gif'
Vue.config.productionTip = false
Vue.use(VueLazyLoad, {
  loading: imgLoading,
})
new Vue({
  // router,
  // store,
  render: (h) => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  },
}).$mount('#app')
